import React, { Component } from "react";
import LoggedContext from "./BusinessObjects/LoggedContext";
import UserProfile from "./Models/UserProfile";
import "devextreme/dist/css/dx.light.css";

import "react-querybuilder/dist/query-builder.scss";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Dictionaries for German and Russian languages
import deMessages from "devextreme/localization/messages/de.json";
import ruMessages from "devextreme/localization/messages/ru.json";
import itMessages from "devextreme/localization/messages/it.json";

// Common and language-specific CLDR JSONs

import { loadMessages } from "devextreme/localization";
import HeaderNavBar from "./Components/Navigation/HeaderNavBar/HeaderNavBar";
import Footer from "./Components/Footer/Footer";
import {
  useAppDispatch,
  useAppSelector,
} from "./BusinessObjects/Redux/app/hook";
import { setCompany } from "./BusinessObjects/Redux/features/app/appSlice";
import { RootState } from "./BusinessObjects/Redux/app/store";
import themes from "./Utils/Themes";
import PortalRoutes from "./Routes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { ThemeProvider } from "@mui/material/styles";
import WebSocketController from "./Components/WebSocketController/WebSocketController";
import { CookiesProvider } from "react-cookie";
import CookieConsent from "react-cookie-consent";

class LoggedComponent extends Component {
  state = {
    username: "",
    tokenAPI: "",
    userProfile: null,
    userPassword: "",
    setUserToken: (UserName: string, TokenAPI: string) => {
      this.setState({ username: UserName, tokenAPI: TokenAPI });
    },
    setUserProfile: (user: UserProfile) => {
      this.setState({ userProfile: user });
    },
    setUserPassword: (item: any) => {
      this.setState({ userPassword: item });
    },
  };

  render() {
    return (
      // @ts-ignore
      <LoggedContext.Provider value={this.state}>
        {
          // @ts-ignore
          this.props.children
        }
      </LoggedContext.Provider>
    );
  }
}

type Props = {};

const App = (props: Props) => {
  const shouldLog = React.useRef(true);

  const company = useAppSelector((state: RootState) => state.app.company);

  let dispatch = useAppDispatch();

  React.useEffect(() => {
    console.log("App in: ", process.env.NODE_ENV);
    if (shouldLog.current) {
      loadMessages(deMessages);
      loadMessages(ruMessages);
      loadMessages(itMessages);

      // Controllo se l'azienda è di ecco oppure di e-cube in base al dominio: https://ecco-dev.e-cube.it/ - http://dev.e-cube.it/

      if (window.location.href.includes("localhost:3000")) {
        dispatch(setCompany("e-cube"));
      } else {
        if (window.location.href.includes("ecco-dev")) {
          dispatch(setCompany("ecco"));
        } else {
          dispatch(setCompany("e-cube"));
        }
      }
    }

    if (shouldLog.current) shouldLog.current = false;
  }, []);

  return (
    <ThemeProvider theme={company === "e-cube" ? themes.ecube : themes.ecco}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <CookiesProvider>
          <LoggedComponent>
            <HeaderNavBar />
            <PortalRoutes />
            <Footer />
            <WebSocketController />
            <CookieConsent
              location="bottom"
              buttonText="Ok"
              cookieName="CubePortalCookie"
              style={{ background: "#2B373B" }}
              buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
              expires={150}
            >
              Questo sito utilizza i cookie per migliorare la tua esperienza di
              navigazione.
            </CookieConsent>
          </LoggedComponent>
        </CookiesProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
